import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Apollo, ApolloBase, gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { API } from 'src/app/shared/constants/APIConstants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private apollo!: ApolloBase;

  // Account information object to store all account-related details
  accountInformation: any = {
    adminInformation: {
      clubName: '',
      primaryActivity: '',
      primaryActivityId: '', // Store the selected activity ID
      contactPersonName: '',
      phoneNumber: null,
      email: '',
      password: '',
    },
    clubInformation: {
      clubAddress: {
        country: 'GB',
        address: '',
        address2: '',
        city: '',
        state: '',
        postCode: '',
      },
      currency: 'GBP',
      clubTnC: '',
      coachDetails: {
        firstName: '',
        lastName: '',
        email: '',
        gender: '',
      },
      termsAccepted: false,
    },
    appIconUrl: '',
    croppedImage: '',
  };

  constructor(private apolloProvider: Apollo, private http: HttpClient) {
    this.apollo = this.apolloProvider.use('gqlActivityProNew');
  }

  // Method to get account information
  getAccountInformation() {
    return this.accountInformation;
  }

  // Method to reset account information
  resetAccountInformation() {
    this.accountInformation = {
      adminInformation: {
        clubName: '',
        primaryActivity: '',
        primaryActivityId: '', // Reset the activity ID as well
        contactPersonName: '',
        phoneNumber: '',
        email: '',
        password: '',
      },
      clubInformation: {
        clubAddress: {
          country: 'GB',
          address: '',
          address2: '',
          city: '',
          state: '',
          postCode: '',
        },
        currency: 'GBP',
        clubTnC: '',
        coachDetails: {
          firstName: '',
          lastName: '',
          email: '',
          gender: '',
        },
        termsAccepted: false,
      },
      appIconUrl: '',
      croppedImage: '',
    };
  }

  checkUserEmailExistance(email: string) {
    return this.apollo
      .watchQuery({
        query: gql`
        {
          checkUserEmailExistance(email: "${email}", parentClubId: "")
        }
      `,
      })
      .valueChanges.pipe();
  }

  getActivities(): Observable<any> {
    return this.http.get<any>(API.PRIMARY_ACTIVITIES);
  }

  checkEmail(payload: any): Observable<any> {
    return this.http.post(API.ADMIN_EMAILS, payload);
  }

  createParentClub(payload: any): Observable<any> {
    return this.http.post(API.CREATE_PARENT_CLUB, payload);
  }

  checkEmailUnique(email: string): Observable<any> {
    return this.http.post(`${environment.api.gatewaySecured}/parentclub/check-email-unique`, {
      email,
      parentclubId: '',
      clubId: '',
      activityId: '',
      memberId: '',
      action_type: 0,
      device_type: 3,
      app_type: 15,
      device_id: '',
    });
  }
}
